<template>
  <div class="dialog-background">
    <div id="login">
      <v-row justify="space-around">
        <v-col cols="auto">
          <div
            class="login"
          >
            <form-outer-card />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import formOuterCard from '../../register-cards/formOuterCard'
import $ from 'jquery'
export default {
  components: { formOuterCard },
  data () {
    return {
    }
  },
  mounted () {
    this.style()
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      this.style()
    })
    window.addEventListener('resize', () => {
      if (window.innerHeight < 425) {
        $('#login').css('top', 0)
      } else {
        this.style()
      }
    })
  },
  methods: {
    style () {
      setTimeout(() => {
        if (this.$store.state.window <= 800 && this.$store.state.window > 536) {
          $('#login').css('top', 'calc(50% - 171px)')
          $('#login').css('left', 'calc(50% - 252px)')
        } else if (this.$store.state.window <= 536 && this.$store.state.window > 400) {
          $('#login').css('left', 'calc(50% - 197.5px)')
          $('#login').css('top', 'calc(50% - 213.5px)')
        } else if (this.$store.state.window <= 400) {
          $('#login').css('top', 'calc(50% - 206px)')
          $('#login').css('left', 'calc(50% - 175px)')
        } else {
          $('#login').css('top', 'calc(50% - 225px)')
          $('#login').css('left', 'calc(50% - 325px)')
        }
        if (window.innerHeight < 425) {
          $('#login').css('top', 0)
        }
      })
    }
  }
}
</script>
<style>
.dialog-background{
  position: fixed;
  z-index: 1000000000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  backdrop-filter: blur(25px);
  overflow-y: auto;
}
div#login{
  position: fixed;
  z-index: 1000000001;
  transition: all .2s ease-in-out;
  /*left: calc(50% - 325px);*/
  top: -100vh;
}
</style>
